// PrivateShowStatusTitle.js
import { connect } from 'react-redux';

import PrivateShowStatusTitle from '../component/PrivateShowStatusTitle.jsx';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getGoalData from '../selector/getGoalData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';

const mapStateToProps = (state, { streamId }) => {
  const fundingId = getLiveStreamData(
    state,
    [streamId, 'privateShow'],
    'fundingId'
  );
  const performingId = getLiveStreamData(
    state,
    [streamId, 'privateShow'],
    'performingId'
  );
  const status = getPrivateShowStatus(state, streamId);
  const timestampOffsetSeconds = getTimestampOffset(state, Accuracy.SECOND);
  const fundingExp = getGoalData(state, [fundingId], 'exp');
  const fundingTarget = getGoalData(state, [fundingId, 'levels', 0], 'target');
  const fundingProgress = getGoalData(state, [fundingId], 'progress');
  const performNbf = getGoalData(state, [performingId], 'nbf');
  const performTarget = getGoalData(
    state,
    [performingId, 'levels', 0],
    'target'
  );
  const performProgress = getGoalData(state, [performingId], 'progress');
  const performStartedUnixTimestamp = getGoalData(
    state,
    [performingId, 'context'],
    'started'
  );

  return {
    status,
    timestampOffsetSeconds,
    fundingExp,
    fundingTarget,
    fundingProgress,
    performNbf,
    performTarget,
    performProgress,
    performStartedUnixTimestamp,
  };
};

export default connect(mapStateToProps, null)(PrivateShowStatusTitle);
